<template>
  <div>

  </div>
</template>

<script>
import mmsService from '@/services/mmsService';
import commonTool from '@/tools/commonTool';
import mbcService from '@/services/mbcService';

export default {
  created() {
    const {
      redirectUri, accountId, companyId, companyTagNo, detlMsgObjectNo, unionId, memberSourceId,
    } = this.$route.query;

    // 新增QRCODE行銷活動訊息點擊紀錄
    const createQRCodeMessageClick = !detlMsgObjectNo ? Promise.resolve()
      : mmsService.createQRCodeMessageClick({ accountId, unionId, clickObjectNo: parseInt(detlMsgObjectNo, 10) }).toPromise();

    // 須符合才作貼標
    if (accountId !== '' && companyId !== '' && companyTagNo) {
      const tagNos = Array.isArray(companyTagNo) ? companyTagNo : [companyTagNo];
      const postMemberTag = mbcService.PostMemberTag({
        companyId,
        accountType: 'LineBind',
        accountId,
        createUser: 'System',
        source: 'QRCodeUri',
        sourceRemark: redirectUri.substring(0, 100),
        companyTagNo: tagNos.map((x) => parseInt(x, 10)),
        sourceRelation: detlMsgObjectNo,
        memberSourceId,
      }).toPromise();

      Promise.all([createQRCodeMessageClick, postMemberTag])
        .finally(() => {
          if (commonTool.checkedMobile() && redirectUri.indexOf('https://liff.line.me') > -1) {
            const newUrl = redirectUri.replace('https://liff.line.me', 'https://line.me/R/app');
            window.location.replace(newUrl);
          } else {
            window.location.replace(redirectUri);
          }
        });
    } else {
      createQRCodeMessageClick
        .finally(() => {
          if (commonTool.checkedMobile() && redirectUri.indexOf('https://liff.line.me') > -1) {
            const newUrl = redirectUri.replace('https://liff.line.me', 'https://line.me/R/app');
            window.location.replace(newUrl);
          } else {
            window.location.replace(redirectUri);
          }
        });
    }
  },
};
</script>
